let SvgList;
export default SvgList = [
  {
    name: "Menu-Icon",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "40",
    d: "M80 160h352M80 256h352M80 352h352",
    viewBox:"0 0 512 512"
  },
  {
    name: "Document-Icon",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "32",
    viewBox:"0 0 512 512",
    ExtraElement: 
      <path key={1} d="M256 56v120a32 32 0 0032 32h120" fill="none"
        stroke="currentColor"
        strokeWidth="32" />
    ,
    d: "M416 221.25V416a48 48 0 01-48 48H144a48 48 0 01-48-48V96a48 48 0 0148-48h98.75a32 32 0 0122.62 9.37l141.26 141.26a32 32 0 019.37 22.62z"
  },
  {
    name: "Clipboard-Icon",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "32",
    viewBox:"0 0 512 512",
    ExtraElement: <rect key={1} x="176" y="32" width="160" height="64" rx="26.13"
      ry="26.13" fill="none" stroke="currentColor" strokeLinejoin="round"
      strokeWidth="32" />,
    d: "M336 64h32a48 48 0 0148 48v320a48 48 0 01-48 48H144a48 48 0 01-48-48V112a48 48 0 0148-48h32"
  },
  {
    name: "Calender-Icon",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "32",
    ExtraElement: <rect key={1} fill="none" stroke="currentColor"
      strokeLinejoin="round" strokeWidth="32" x="48" y="80"
      width="416" height="384" rx="48" />,
    d: "M128 48v32M384 48v32M464 160H48",
    viewBox:"0 0 512 512"
  },
  {
    name: "Plus-Icon",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "32",
    d: "M256 112v288M400 256H112",
    viewBox:"0 0 512 512"
  },
  {
    name: "Grid-Icon",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "32",
    viewBox:"0 0 512 512",
    ExtraElement: <>
    <rect key={1} x="48" y="48" width="176" height="176" rx="20"
      ry="20" fill="none" stroke="currentColor" strokeLinecap="round"
      strokeLinejoin="round" strokeWidth="32" />
    <rect key={2} x="288" y="48" width="176" height="176" rx="20"
      ry="20" fill="none" stroke="currentColor" strokeLinecap="round"
      strokeLinejoin="round" strokeWidth="32" />
    <rect key={3} x="48" y="288" width="176" height="176" rx="20" ry="20" fill="none"
      stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"
      strokeWidth="32" />
    <rect key={4} x="288" y="288" width="176" height="176" rx="20"
      ry="20" fill="none" stroke="currentColor" strokeLinecap="round"
        strokeLinejoin="round" strokeWidth="32" /></>
    
  },
  {
    name: "Alert-Icon",
    stroke: "currentColor",
    ExtraElement: 
      <>
        <path key={1} d="M250.26 166.05L256 288l5.73-121.95a5.74 5.74 0 00-5.79-6h0a5.74 5.74 0 00-5.68 6z" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" />
        <path key={2} d="M256 367.91a20 20 0 1120-20 20 20 0 01-20 20z" fill="currentColor" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      </>
    ,
    fill: "none",
    strokeWidth:"32",
    d: `M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z`,
    viewBox:"0 0 512 512"
  },
  {
    name: "CheckMark-Icon",
    stroke: "currentColor",
    viewBox:"0 0 24 24",
    fill: "none",
    strokeWidth:"1.5",
    d: `M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z`
  },
  {
    name: "Info-Icon",
    viewBox:"0 0 24 24",
    fill: "none",
    strokeWidth:"1.5",
    d: `M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z`
  },
  {
    name: "Edit-Icon",
    d: `M384 224v184a40 40 0 01-40 40H104a40 40 0 01-40-40V168a40 40 0 0140-40h167.48`,
    viewBox: "0 0 512 512",
    fill: "none",
    strokeWidth: "32",
    ExtraElement: [
      <path key={1} d="M459.94 53.25a16.06 16.06 0 00-23.22-.56L424.35 65a8 8 0 000 11.31l11.34 11.32a8 8 0 0011.34 0l12.06-12c6.1-6.09 6.67-16.01.85-22.38zM399.34 90L218.82 270.2a9 9 0 00-2.31 3.93L208.16 299a3.91 3.91 0 004.86 4.86l24.85-8.35a9 9 0 003.93-2.31L422 112.66a9 9 0 000-12.66l-9.95-10a9 9 0 00-12.71 0z"/>
    ]
  },
  {
    name: "Grip-Icon",
    d: `M7 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z`,
    viewBox: "0 0 16 16",
  },
  {
    name: "Profile-Icon",
    d: `M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z`,
    viewBox: "0 0 16 16",
    ExtraElement: [
      <path key={1} fillRule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z"/>
    ]
  },
  {
    name: "Trash-Icon",
    d: `M112 112l20 320c.95 18.49 14.4 32 32 32h184c17.67 0 30.87-13.51 32-32l20-320`,
    fill: "none",
    strokeWidth: "32",
    viewBox: "0 0 512 512",
    ExtraElement: [
      <path key={1} fill="none" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="32" d="M80 112h352" />,
      <path key={2} d="M192 112V72h0a23.93 23.93 0 0124-24h80a23.93 23.93 0 0124 24h0v40M256 176v224M184 176l8 224M328 176l-8 224" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" />
    ]
  }

]